import { IDeleteChecklistServicoLiberacaoUseCase } from "../../../presentation/useCases/delete/delete_checklist_servico_liberacao_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteChecklistServicoLiberacaoUseCase
 */

export class DeleteChecklistServicoLiberacaoUseCase implements IDeleteChecklistServicoLiberacaoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idChecklistServicoLiberacao: number,
  ): Promise<void> {
    await this.repository.deleteChecklistServicoLiberacao(
      idChecklistServicoLiberacao,
    );
  }
}
